import { DocumentoDetalle } from "./DocumentoDetalle";
import { Documento } from "./documento";

export class CorteCajaWrapper {
    // Seccion Metodos Pago y Retiros
    detalleMetodosPago: DocumentoDetalle[];
    detalleRetiros: DocumentoDetalle;
    detalleTotalMetodosPago: DocumentoDetalle;

    // Seccion Ingresos
    detalleDenominaciones: DocumentoDetalle[];
    detalleEfectivo: DocumentoDetalle;
    detalleVoucher: DocumentoDetalle;
    detalleIngresos: DocumentoDetalle;

    // Seccion Detalle Corte
    detalleFondoCaja: DocumentoDetalle;
    detalleDiferencia: DocumentoDetalle;
    
    corteDetalle: Documento;

    usuario: string;
    contrasena: string;

    documentId: number;
}


// WEBPACK FOOTER //
// ./src/app/models/corte-caja-wrapper.ts